import React from "react";
import * as Icons from "@material-ui/icons";
import {
  Grid,
  createStyles,
  makeStyles,
  Box,
  Fab,
  Tooltip,
  List,
  ListItem,
  ListItemIcon,
  Typography,
  ListItemText,
} from "@material-ui/core";
import DefaultModal, {
  DefaultModalContent,
} from "../../../Components/DefaultModal";
import { UserContext } from "../../../Context/UserContext";
import NewEdit from "./Edit";
import ConfirmDelete from "./ConfirmDelete";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: "1.5rem 0px 1rem 0px",
      margin: 0,
    },
    main: {
      minHeight: 100,
      [theme.breakpoints.up("xs")]: {
        width: 380,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("sm")]: {
        width: 450,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("md")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("lg")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("xl")]: {
        width: 600,
        padding: theme.spacing(0, 1, 0, 1),
      },
    },
  })
);

export function ViewModal({ data, setData, open, setOpen, updateData }) {
  const classes = useStyles();
  const { privilege } = React.useContext(UserContext);
  const [select, setSelect] = React.useState(null);
  const [openView, setOpenView] = React.useState(false);

  console.log("data", data)

  const handleOpenView = (data) => {
    setSelect(data);
    setOpenView(true);
  };

  const handleCloseView = () => {
    setOpenView(false);
    setSelect(null);
  };

  const handleClose = () => {
    handleCloseView();
    setOpen();
  };

  const fullUpdate = () => {
    updateData();
  };

  const getSelectContent = React.useCallback(
    (select) => {
      switch (select) {
        case 0: return <ConfirmDelete id={parseInt(data.id ?? "0")} open={openView} setOpen={handleCloseView} handleClose={handleClose} updateData={fullUpdate}/>
        case 1: return <NewEdit data={data} setData={setData} open={openView} setOpen={handleCloseView} updateData={fullUpdate}/>
        default:
          return null;
      }
    },
    [select]
  );

  return (
    <>
      {getSelectContent(select)}
      <DefaultModal
        loading={data === null}
        open={open}
        handleClose={setOpen}
        title={`Vereador`}
        actionsTitle={
          <Box>
            <Tooltip
              placement="top"
              title="Apagar programa"
              aria-label="Apagar programa"
            >
              <span>
                <Fab
                  size="small"
                  color="primary"
                  aria-label="edit"
                  style={{ backgroundColor: "red" }}
                  disabled={!privilege.administrator}
                  onClick={() => handleOpenView(0)}
                >
                  <Icons.Delete />
                </Fab>
              </span>
            </Tooltip>
            <Tooltip
              placement="top"
              title="Editar programa"
              aria-label="Editar programa"
            >
              <span>
                <Fab
                  style={{ marginLeft: "1rem" }}
                  size="small"
                  color="primary"
                  aria-label="edit"
                  disabled={!privilege.administrator}
                  onClick={() => handleOpenView(1)}
                >
                  <Icons.Edit />
                </Fab>
              </span>
            </Tooltip>
          </Box>
        } 
      >
        <DefaultModalContent dividers className={classes.main}>
          <Grid container className={classes.root}>
            <Grid item xs={12}>
              <List dense disablePadding>
                {data !== null && (
                  <ListItem>
                    <ListItemIcon>
                      <Icons.Person />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Typography variant="h6" component="span">Nome: {data.name}</Typography>}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          </Grid>
        </DefaultModalContent>
      </DefaultModal>
    </>
  );
}
